module.exports = __webpack_public_path__ + "img/client2.2e75c7fc.png";